(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-collection-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var moduleKey = '__fhqBrandCollection';
    if (window[moduleKey]) {
      window[moduleKey].init(document);
      return;
    }

    var sectionBindings = new WeakMap();

    var getSeriesSections = function (scope) {
      if (!scope) return [];
      if (scope.matches && scope.matches('[data-brand-series-section]')) return [scope];
      if (!scope.querySelectorAll) return [];
      return Array.prototype.slice.call(scope.querySelectorAll('[data-brand-series-section]'));
    };

    var cleanupSeriesSections = function (scope) {
      getSeriesSections(scope).forEach(function (section) {
        var controller = sectionBindings.get(section);
        if (controller) controller.abort();
        sectionBindings.delete(section);
        delete section.dataset.seriesBound;
      });
    };

    var initSeriesSections = function (scope) {
      var sections = getSeriesSections(scope);

      sections.forEach(function (section) {
        if (section.dataset.seriesBound === 'true' || sectionBindings.has(section)) return;

        var controller = new AbortController();
        var listenerOptions = { signal: controller.signal };
        sectionBindings.set(section, controller);

        var filterDisclosure = section.querySelector('[data-brand-filter]');
        var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-series-trigger]'));
        var panels = Array.prototype.slice.call(section.querySelectorAll('[data-series-panel]'));
        var cards = Array.prototype.slice.call(section.querySelectorAll('[data-series-card]'));
        var count = section.querySelector('[data-series-product-count]');

        if (filterDisclosure) {
          var desktopFilterQuery = window.matchMedia('(min-width: 901px)');
          var mobileFilterOpen = filterDisclosure.open;
          var syncingFilter = false;

          var syncFilterDisclosure = function () {
            syncingFilter = true;
            filterDisclosure.open = desktopFilterQuery.matches ? true : mobileFilterOpen;
            syncingFilter = false;
          };

          filterDisclosure.addEventListener('toggle', function () {
            if (syncingFilter) return;
            if (desktopFilterQuery.matches) {
              if (!filterDisclosure.open) syncFilterDisclosure();
              return;
            }
            mobileFilterOpen = filterDisclosure.open;
          }, listenerOptions);

          if (desktopFilterQuery.addEventListener) {
            desktopFilterQuery.addEventListener('change', syncFilterDisclosure, listenerOptions);
          } else {
            desktopFilterQuery.addListener(syncFilterDisclosure);
            controller.signal.addEventListener('abort', function () {
              desktopFilterQuery.removeListener(syncFilterDisclosure);
            }, { once: true });
          }

          syncFilterDisclosure();
        }

        var activateSeries = function (seriesId) {
          var activePanel = panels.find(function (panel) {
            return panel.dataset.seriesPanel === seriesId;
          });
          if (!activePanel) return;

          panels.forEach(function (panel) {
            var active = panel.dataset.seriesPanel === seriesId;
            panel.hidden = !active;
          });

          cards.forEach(function (card) {
            card.classList.toggle('is-active', card.dataset.seriesCard === seriesId);
          });

          triggers.forEach(function (trigger) {
            var active = trigger.dataset.seriesTrigger === seriesId;
            if (trigger.matches('input')) trigger.checked = active;
            if (trigger.matches('button')) trigger.setAttribute('aria-pressed', String(active));
          });

          if (count && activePanel) count.textContent = activePanel.dataset.productCount || '0';
        };

        triggers.forEach(function (trigger) {
          var eventName = trigger.matches('input') ? 'change' : 'click';
          trigger.addEventListener(eventName, function () {
            activateSeries(trigger.dataset.seriesTrigger);
          }, listenerOptions);
        });

        section.addEventListener('shopify:block:select', function (event) {
          var card = event.target.closest('[data-series-card]');
          if (card && section.contains(card)) activateSeries(card.dataset.seriesCard);
        }, listenerOptions);

        section.dataset.seriesBound = 'true';
      });
    };

    window[moduleKey] = {
      init: initSeriesSections,
      cleanup: cleanupSeriesSections
    };

    initSeriesSections(document);
    document.addEventListener('shopify:section:load', function (event) {
      initSeriesSections(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      cleanupSeriesSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.FHQFaqAnimations) {
      window.FHQFaqAnimations.setup(document);
      return;
    }

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);

    const clearAnimationState = (details) => {
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      details.classList.remove('is-animating');
    };

    const finishImmediately = (details) => {
      if (details.fhqAnimation) details.fhqAnimation.cancel();
      if (details.fhqPanelAnimation) details.fhqPanelAnimation.cancel();
      details.fhqAnimation = null;
      details.fhqPanelAnimation = null;
      details.open = details.dataset.fhqTarget === 'open';
      clearAnimationState(details);
    };

    const animateDetails = (details) => {
      const summary = details.querySelector('summary');
      const panel = details.querySelector('[data-fhq-faq-panel]');
      if (!summary || !panel) return;

      const opening = details.dataset.fhqTarget !== 'open';
      const currentHeight = details.getBoundingClientRect().height;
      details.dataset.fhqTarget = opening ? 'open' : 'closed';

      if (details.fhqAnimation) details.fhqAnimation.cancel();
      if (details.fhqPanelAnimation) details.fhqPanelAnimation.cancel();

      details.style.height = `${currentHeight}px`;
      details.style.overflow = 'hidden';
      details.classList.add('is-animating');
      if (opening) details.open = true;

      const borderHeight = details.offsetHeight - details.clientHeight;
      const endHeight = opening
        ? summary.getBoundingClientRect().height + panel.scrollHeight + borderHeight
        : summary.getBoundingClientRect().height + borderHeight;
      const duration = opening ? 300 : 220;
      const animation = details.animate([
        { height: `${currentHeight}px` },
        { height: `${endHeight}px` }
      ], {
        duration,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
      });
      const panelAnimation = panel.animate(opening
        ? [
            { opacity: 0, transform: 'translateY(-6px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ]
        : [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(-4px)' }
          ], {
        duration: opening ? 180 : 140,
        delay: opening ? 50 : 0,
        easing: 'ease',
        fill: 'both'
      });

      details.fhqAnimation = animation;
      details.fhqPanelAnimation = panelAnimation;

      animation.finished.then(() => {
        if (details.fhqAnimation !== animation) return;
        if (!opening) details.open = false;
        if (details.fhqPanelAnimation) {
          const activePanelAnimation = details.fhqPanelAnimation;
          details.fhqPanelAnimation = null;
          activePanelAnimation.cancel();
        }
        details.fhqAnimation = null;
        clearAnimationState(details);
      }).catch(() => {});
    };

    const handleClick = (event) => {
      const summary = event.target.closest('.faq-list summary');
      if (!summary) return;
      const details = summary.parentElement;
      if (!details || !details.matches('.faq-list details')) return;
      if (motionQuery.matches || designMode || typeof details.animate !== 'function') return;
      if (!details.querySelector('[data-fhq-faq-panel]')) return;
      event.preventDefault();
      const section = details.closest('.faq-section');
      if (section) {
        section.querySelectorAll('.faq-list details.is-animating').forEach((item) => {
          if (item !== details) finishImmediately(item);
        });
      }
      animateDetails(details);
    };

    const setup = (root) => {
      const sections = [];
      if (root && root.matches && root.matches('.faq-section')) sections.push(root);
      if (root && root.querySelectorAll) sections.push(...root.querySelectorAll('.faq-section'));

      sections.forEach((section) => {
        if (section.dataset.fhqFaqBound === 'true') return;
        section.dataset.fhqFaqBound = 'true';
        section.addEventListener('click', handleClick);
        section.querySelectorAll('.faq-list details').forEach((details) => {
          details.dataset.fhqTarget = details.open ? 'open' : 'closed';
          details.fhqToggleHandler = () => {
            if (!details.fhqAnimation) details.dataset.fhqTarget = details.open ? 'open' : 'closed';
          };
          details.addEventListener('toggle', details.fhqToggleHandler);
        });
      });
    };

    const teardown = (root) => {
      const sections = [];
      if (root && root.matches && root.matches('.faq-section')) sections.push(root);
      if (root && root.querySelectorAll) sections.push(...root.querySelectorAll('.faq-section'));

      sections.forEach((section) => {
        section.removeEventListener('click', handleClick);
        section.querySelectorAll('.faq-list details').forEach((details) => {
          finishImmediately(details);
          if (details.fhqToggleHandler) details.removeEventListener('toggle', details.fhqToggleHandler);
          details.fhqToggleHandler = null;
        });
        delete section.dataset.fhqFaqBound;
      });
    };

    window.FHQFaqAnimations = { setup, teardown, finishImmediately };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
    } else {
      setup(document);
    }

    document.addEventListener('shopify:section:load', (event) => setup(event.target));
    document.addEventListener('shopify:section:unload', (event) => teardown(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const details = event.target.closest('.faq-list details');
      if (!details) return;
      details.dataset.fhqTarget = 'open';
      finishImmediately(details);
    });

    const handleMotionChange = (event) => {
      if (!event.matches) return;
      document.querySelectorAll('.faq-list details.is-animating').forEach(finishImmediately);
    };

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', handleMotionChange);
    } else {
      motionQuery.addListener(handleMotionChange);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.FidgetHQLiveSearch) {
      window.FidgetHQLiveSearch.init(document);
      return;
    }

    var toArray = function (items) {
      return Array.prototype.slice.call(items || []);
    };

    var formsWithin = function (root) {
      var forms = [];
      if (root && root.matches && root.matches('[data-live-search]')) forms.push(root);
      if (root && root.querySelectorAll) forms = forms.concat(toArray(root.querySelectorAll('[data-live-search]')));
      return forms;
    };

    var searchRoute = function (query) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      return root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6';
    };

    var resizeImage = function (source) {
      if (!source) return '';
      try {
        var url = new URL(source, window.location.href);
        if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '96');
        return url.toString();
      } catch (error) {
        return source;
      }
    };

    var initForm = function (form) {
      if (form.dataset.liveSearchBound === 'true') return;

      var input = form.querySelector('[data-live-search-input]');
      var results = form.querySelector('[data-live-search-results]');
      var status = form.querySelector('[data-live-search-status]');
      if (!input || !results) return;

      form.dataset.liveSearchBound = 'true';
      var timeout = null;
      var controller = null;
      var requestSequence = 0;
      var activeIndex = -1;

      var options = function () {
        return toArray(results.querySelectorAll('[data-live-search-option]'));
      };

      var close = function (clearMarkup) {
        activeIndex = -1;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        results.hidden = true;
        if (clearMarkup) results.textContent = '';
        options().forEach(function (option) {
          option.classList.remove('is-active');
          option.setAttribute('aria-selected', 'false');
        });
      };

      var activate = function (index) {
        var items = options();
        if (!items.length) return;
        activeIndex = (index + items.length) % items.length;
        items.forEach(function (item, itemIndex) {
          var selected = itemIndex === activeIndex;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        input.setAttribute('aria-activedescendant', items[activeIndex].id);
      };

      var render = function (products) {
        results.textContent = '';
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');

        products.forEach(function (product, index) {
          var option = document.createElement('a');
          option.id = results.id + '-Option-' + index;
          option.href = product.url;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          option.setAttribute('tabindex', '-1');
          option.setAttribute('data-live-search-option', '');

          var imageSource = product.featured_image && product.featured_image.url;
          if (imageSource) {
            var image = document.createElement('img');
            image.src = resizeImage(imageSource);
            image.alt = '';
            image.width = 48;
            image.height = 48;
            image.loading = 'lazy';
            image.decoding = 'async';
            option.appendChild(image);
          } else {
            var placeholder = document.createElement('span');
            placeholder.setAttribute('aria-hidden', 'true');
            option.appendChild(placeholder);
          }

          var title = document.createElement('span');
          title.textContent = product.title || '';
          option.appendChild(title);
          results.appendChild(option);
        });

        if (!products.length) {
          close(true);
          if (status) status.textContent = form.dataset.searchEmpty || '';
          return;
        }

        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        if (status) status.textContent = form.dataset.searchUpdated || '';
      };

      var onInput = function () {
        window.clearTimeout(timeout);
        requestSequence += 1;
        if (controller) controller.abort();
        controller = null;

        var query = input.value.trim();
        if (query.length < 2) {
          close(true);
          if (status) status.textContent = '';
          return;
        }

        var currentRequest = requestSequence;
        timeout = window.setTimeout(function () {
          controller = typeof AbortController === 'function' ? new AbortController() : null;
          var fetchOptions = { headers: { Accept: 'application/json' } };
          if (controller) fetchOptions.signal = controller.signal;

          fetch(searchRoute(query), fetchOptions)
            .then(function (response) {
              if (!response.ok) throw new Error('Search request failed');
              return response.json();
            })
            .then(function (payload) {
              if (currentRequest !== requestSequence || input.value.trim() !== query) return;
              render(((((payload || {}).resources || {}).results || {}).products) || []);
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              if (currentRequest !== requestSequence || input.value.trim() !== query) return;
              render([]);
            });
        }, 220);
      };

      var onKeydown = function (event) {
        var items = options();
        if (event.key === 'Escape') {
          if (input.getAttribute('aria-expanded') === 'true') {
            event.preventDefault();
            close(false);
          }
          return;
        }
        if (!items.length || results.hidden) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activate(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activate(activeIndex - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          activate(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          activate(items.length - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          items[activeIndex].click();
        }
      };

      var onFocusOut = function () {
        window.requestAnimationFrame(function () {
          if (!form.contains(document.activeElement)) close(false);
        });
      };

      input.addEventListener('input', onInput);
      input.addEventListener('keydown', onKeydown);
      form.addEventListener('focusout', onFocusOut);
      form._liveSearchCleanup = function () {
        window.clearTimeout(timeout);
        requestSequence += 1;
        if (controller) controller.abort();
        input.removeEventListener('input', onInput);
        input.removeEventListener('keydown', onKeydown);
        form.removeEventListener('focusout', onFocusOut);
        delete form._liveSearchCleanup;
        delete form.dataset.liveSearchBound;
      };
    };

    var liveSearch = {
      init: function (root) {
        formsWithin(root).forEach(initForm);
      },
      teardown: function (root) {
        formsWithin(root).forEach(function (form) {
          if (form._liveSearchCleanup) form._liveSearchCleanup();
        });
      }
    };

    window.FidgetHQLiveSearch = liveSearch;
    liveSearch.init(document);
    document.addEventListener('shopify:section:load', function (event) {
      liveSearch.init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      liveSearch.teardown(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fidgethq-hero-slider')) {
    class FidgetHQHeroSlider extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.timerId = null;
        this.autoplayGeneration = 0;
        this.navigationVersion = 0;
        this.lifecycleVersion = 0;
        this.preloadIdleId = null;
        this.preloadTimeoutId = null;
        this.pointerResetId = null;
        this.editorPaused = false;
        this.pointerPaused = false;
        this.userPaused = false;
        this.pointerActivatingRotationControl = false;
        this.autoplayReady = false;
        this.initialized = false;
        this.pendingImageCleanups = new Set();
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerEnter = this.handlePointerEnter.bind(this);
        this.handlePointerLeave = this.handlePointerLeave.bind(this);
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.lifecycleVersion += 1;
        const lifecycleVersion = this.lifecycleVersion;
        this.pointerPaused = false;
        this.pointerActivatingRotationControl = false;
        this.slides = Array.from(this.querySelectorAll('[data-fhq-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-fhq-hero-dot]'));
        this.status = this.querySelector('[data-fhq-hero-status]');
        this.controls = this.querySelector('[data-fhq-hero-controls]');
        this.rotationToggle = this.querySelector('[data-fhq-hero-rotation-toggle]');
        this.rotationLabel = this.querySelector('[data-fhq-hero-rotation-label]');
        this.pauseIcon = this.querySelector('[data-fhq-hero-pause-icon]');
        this.playIcon = this.querySelector('[data-fhq-hero-play-icon]');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
        this.editorPaused = this.designMode;
        this.interval = Math.max(3000, Number.parseInt(this.dataset.interval, 10) || 6000);
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        const activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        this.activateSlide(activeIndex >= 0 ? activeIndex : 0, false, false);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('pointerdown', this.handlePointerDown);
        this.addEventListener('pointerenter', this.handlePointerEnter);
        this.addEventListener('pointerleave', this.handlePointerLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        if (typeof this.motionQuery.addEventListener === 'function') {
          this.motionQuery.addEventListener('change', this.handleMotionChange);
        } else {
          this.motionQuery.addListener(this.handleMotionChange);
        }

        this.handleMotionChange();
        this.updateRotationControl();
        if (this.controls) this.controls.hidden = false;

        const initialSlide = this.slides[this.currentIndex];
        this.waitForSlideImage(initialSlide, 8000).then(() => {
          if (!this.initialized || lifecycleVersion !== this.lifecycleVersion) return;
          this.autoplayReady = true;
          this.scheduleNextPreload();
          this.startAutoplay();
        });
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.initialized = false;
        this.lifecycleVersion += 1;
        this.navigationVersion += 1;
        this.stopAutoplay();
        this.cancelScheduledPreload();
        this.cancelPendingImageWaits();
        if (this.pointerResetId !== null) {
          window.clearTimeout(this.pointerResetId);
          this.pointerResetId = null;
        }
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('pointerdown', this.handlePointerDown);
        this.removeEventListener('pointerenter', this.handlePointerEnter);
        this.removeEventListener('pointerleave', this.handlePointerLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);

        if (this.motionQuery) {
          if (typeof this.motionQuery.removeEventListener === 'function') {
            this.motionQuery.removeEventListener('change', this.handleMotionChange);
          } else {
            this.motionQuery.removeListener(this.handleMotionChange);
          }
        }

        if (this.controls) this.controls.hidden = true;
        this.autoplayReady = false;
        this.pointerActivatingRotationControl = false;
      }

      getSlideImage(slide) {
        return slide ? slide.querySelector('.fhq-hero__image') : null;
      }

      hydrateSlideImage(slide) {
        const image = this.getSlideImage(slide);
        if (!image || !image.hasAttribute('data-fhq-deferred-image')) return image;

        const picture = image.closest('picture');
        if (picture) {
          picture.querySelectorAll('source[data-srcset]').forEach((source) => {
            source.setAttribute('srcset', source.dataset.srcset);
            source.removeAttribute('data-srcset');
          });
        }

        if (image.dataset.sizes) {
          image.setAttribute('sizes', image.dataset.sizes);
          image.removeAttribute('data-sizes');
        }
        if (image.dataset.srcset) {
          image.setAttribute('srcset', image.dataset.srcset);
          image.removeAttribute('data-srcset');
        }
        if (image.dataset.src) {
          image.setAttribute('src', image.dataset.src);
          image.removeAttribute('data-src');
        }
        image.removeAttribute('data-fhq-deferred-image');
        return image;
      }

      preloadSlideImage(slide, priority = 'low') {
        const image = this.getSlideImage(slide);
        if (!image) return;

        if (image.getAttribute('fetchpriority') !== 'high') {
          image.setAttribute('fetchpriority', priority);
        }
        if (image.getAttribute('loading') === 'lazy') {
          image.setAttribute('loading', 'eager');
        }
        this.hydrateSlideImage(slide);
      }

      waitForSlideImage(slide, timeout = 6000) {
        const image = this.getSlideImage(slide);
        if (!image) return Promise.resolve(true);
        if (image.complete) return Promise.resolve(image.naturalWidth > 0);

        return new Promise((resolve) => {
          let settled = false;
          let timeoutId = null;

          const cleanup = () => {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
            if (timeoutId !== null) window.clearTimeout(timeoutId);
            this.pendingImageCleanups.delete(cancel);
          };

          const finish = (loaded) => {
            if (settled) return;
            settled = true;
            cleanup();
            resolve(loaded);
          };

          const handleLoad = () => finish(true);
          const handleError = () => finish(false);

          const cancel = () => finish(false);

          this.pendingImageCleanups.add(cancel);
          image.addEventListener('load', handleLoad, { once: true });
          image.addEventListener('error', handleError, { once: true });
          timeoutId = window.setTimeout(() => finish(false), timeout);
        });
      }

      cancelPendingImageWaits() {
        Array.from(this.pendingImageCleanups).forEach((cancel) => cancel());
      }

      cancelScheduledPreload() {
        if (this.preloadIdleId !== null && typeof window.cancelIdleCallback === 'function') {
          window.cancelIdleCallback(this.preloadIdleId);
        }
        if (this.preloadTimeoutId !== null) {
          window.clearTimeout(this.preloadTimeoutId);
        }
        this.preloadIdleId = null;
        this.preloadTimeoutId = null;
      }

      scheduleNextPreload() {
        this.cancelScheduledPreload();
        if (
          !this.initialized ||
          !this.autoplayEnabled ||
          this.slides.length < 2 ||
          this.userPaused ||
          this.editorPaused ||
          this.pointerPaused ||
          document.hidden ||
          this.motionQuery.matches
        ) return;

        const scheduledIndex = this.currentIndex;
        const scheduledLifecycle = this.lifecycleVersion;
        const run = () => {
          this.preloadIdleId = null;
          this.preloadTimeoutId = null;
          if (
            !this.initialized ||
            scheduledLifecycle !== this.lifecycleVersion ||
            this.currentIndex !== scheduledIndex ||
            this.userPaused ||
            this.editorPaused ||
            this.pointerPaused ||
            document.hidden ||
            this.motionQuery.matches
          ) return;
          const nextIndex = (scheduledIndex + 1) % this.slides.length;
          this.preloadSlideImage(this.slides[nextIndex], 'low');
        };

        if (typeof window.requestIdleCallback === 'function') {
          this.preloadIdleId = window.requestIdleCallback(run, { timeout: 1500 });
        } else {
          this.preloadTimeoutId = window.setTimeout(run, 250);
        }
      }

      activateSlide(index, announce = false, schedulePreload = true) {
        if (!this.slides.length) return;
        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        this.currentIndex = normalizedIndex;
        this.cancelScheduledPreload();

        // 只提升即将显示的真实 DOM 图片，让 <picture> 自行选择移动或桌面资源。
        this.preloadSlideImage(this.slides[normalizedIndex], 'auto');

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === normalizedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.toggleAttribute('inert', !isActive);
          if (isActive) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (announce && this.status) {
          this.status.textContent = this.slides[normalizedIndex].getAttribute('aria-label') || '';
        }

        if (schedulePreload) {
          const expectedIndex = normalizedIndex;
          const lifecycleVersion = this.lifecycleVersion;
          this.waitForSlideImage(this.slides[normalizedIndex]).then(() => {
            if (
              !this.initialized ||
              lifecycleVersion !== this.lifecycleVersion ||
              this.currentIndex !== expectedIndex
            ) return;
            this.scheduleNextPreload();
          });
        }
      }

      requestSlide(index, announce = false) {
        if (!this.slides.length) return Promise.resolve(false);
        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        const requestVersion = this.navigationVersion + 1;
        const lifecycleVersion = this.lifecycleVersion;
        this.navigationVersion = requestVersion;
        this.cancelScheduledPreload();
        this.preloadSlideImage(this.slides[normalizedIndex], 'auto');

        return this.waitForSlideImage(this.slides[normalizedIndex]).then((loaded) => {
          if (
            !this.initialized ||
            lifecycleVersion !== this.lifecycleVersion ||
            !loaded ||
            requestVersion !== this.navigationVersion
          ) return false;
          this.activateSlide(normalizedIndex, announce);
          return true;
        });
      }

      navigateToSlide(index, announce = false) {
        this.stopAutoplay();
        const lifecycleVersion = this.lifecycleVersion;
        const request = this.requestSlide(index, announce);
        const requestVersion = this.navigationVersion;
        request.then(() => {
          if (
            this.initialized &&
            lifecycleVersion === this.lifecycleVersion &&
            requestVersion === this.navigationVersion
          ) this.startAutoplay();
        });
        return request;
      }

      canAutoplay() {
        return Boolean(
          this.initialized &&
          this.autoplayReady &&
          this.autoplayEnabled &&
          this.slides.length > 1 &&
          !this.editorPaused &&
          !this.pointerPaused &&
          !this.userPaused &&
          !document.hidden &&
          !this.motionQuery.matches
        );
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.canAutoplay()) return;

        const generation = this.autoplayGeneration;
        const lifecycleVersion = this.lifecycleVersion;
        this.timerId = window.setTimeout(
          () => this.handleAutoplayTick(generation, lifecycleVersion),
          this.interval
        );
        this.classList.add('is-autoplaying');
      }

      stopAutoplay() {
        this.autoplayGeneration += 1;
        this.classList.remove('is-autoplaying');
        if (this.timerId !== null) {
          window.clearTimeout(this.timerId);
          this.timerId = null;
        }
      }

      handleAutoplayTick(generation, lifecycleVersion) {
        if (
          lifecycleVersion !== this.lifecycleVersion ||
          generation !== this.autoplayGeneration ||
          !this.canAutoplay()
        ) return;
        this.timerId = null;
        this.classList.remove('is-autoplaying');

        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        const requestVersion = this.navigationVersion + 1;
        this.navigationVersion = requestVersion;
        this.preloadSlideImage(this.slides[nextIndex], 'auto');
        this.waitForSlideImage(this.slides[nextIndex]).then((loaded) => {
          if (
            !this.initialized ||
            lifecycleVersion !== this.lifecycleVersion ||
            generation !== this.autoplayGeneration ||
            requestVersion !== this.navigationVersion ||
            !this.canAutoplay()
          ) return;
          if (loaded) this.activateSlide(nextIndex);
          this.startAutoplay();
        });
      }

      handleClick(event) {
        const rotationToggle = event.target.closest('[data-fhq-hero-rotation-toggle]');
        if (rotationToggle && this.contains(rotationToggle)) {
          this.userPaused = !this.userPaused;
          if (this.userPaused) {
            this.stopAutoplay();
            this.cancelScheduledPreload();
          } else {
            this.scheduleNextPreload();
            this.startAutoplay();
          }
          this.updateRotationControl();
          return;
        }

        const dot = event.target.closest('[data-fhq-hero-dot]');
        if (dot && this.contains(dot)) {
          this.navigateToSlide(Number.parseInt(dot.dataset.slideIndex, 10), true);
        }
      }

      handleKeydown(event) {
        const dot = event.target.closest('[data-fhq-hero-dot]');
        if (!dot || !this.contains(dot)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = this.currentIndex;
        if (event.key === 'ArrowLeft') nextIndex -= 1;
        if (event.key === 'ArrowRight') nextIndex += 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.slides.length - 1;
        nextIndex = (nextIndex + this.slides.length) % this.slides.length;
        this.navigateToSlide(nextIndex, true);
        this.dots[nextIndex].focus();
      }

      handlePointerDown(event) {
        this.pointerActivatingRotationControl = Boolean(event.target.closest('[data-fhq-hero-rotation-toggle]'));
        if (this.pointerResetId !== null) window.clearTimeout(this.pointerResetId);
        this.pointerResetId = window.setTimeout(() => {
          this.pointerActivatingRotationControl = false;
          this.pointerResetId = null;
        }, 0);
      }

      handlePointerEnter() {
        this.pointerPaused = true;
        this.stopAutoplay();
      }

      handlePointerLeave() {
        this.pointerPaused = false;
        if (this.autoplayReady) this.scheduleNextPreload();
        this.startAutoplay();
      }

      handleFocusIn(event) {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        if (this.pointerActivatingRotationControl) {
          this.stopAutoplay();
          return;
        }

        this.userPaused = true;
        this.stopAutoplay();
        this.cancelScheduledPreload();
        this.updateRotationControl();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
          this.cancelScheduledPreload();
        } else {
          if (this.autoplayReady) this.scheduleNextPreload();
          this.startAutoplay();
        }
      }

      handleMotionChange() {
        if (this.motionQuery.matches) {
          this.stopAutoplay();
          this.cancelScheduledPreload();
        } else {
          if (this.autoplayReady) this.scheduleNextPreload();
          this.startAutoplay();
        }
        this.updateRotationControl();
      }

      updateRotationControl() {
        if (!this.rotationToggle) return;
        const actionLabel = this.userPaused
          ? this.rotationToggle.dataset.playLabel
          : this.rotationToggle.dataset.pauseLabel;

        this.rotationToggle.hidden = this.designMode || this.motionQuery.matches;
        this.rotationToggle.setAttribute('aria-label', actionLabel);
        if (this.rotationLabel) this.rotationLabel.textContent = actionLabel;
        if (this.pauseIcon) this.pauseIcon.hidden = this.userPaused;
        if (this.playIcon) this.playIcon.hidden = !this.userPaused;
      }

      handleBlockSelect(event) {
        const slide = event.target.closest('[data-fhq-hero-slide]');
        if (!slide || !this.contains(slide)) return;
        this.editorPaused = true;
        this.stopAutoplay();
        this.cancelScheduledPreload();
        this.requestSlide(this.slides.indexOf(slide));
      }

      handleBlockDeselect() {
        this.editorPaused = this.designMode;
        this.startAutoplay();
      }
    }

    customElements.define('fidgethq-hero-slider', FidgetHQHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var initCartPage = function (root) {
      var form = root && root.matches && root.matches('[data-cart-page-form]')
        ? root
        : root && root.querySelector && root.querySelector('[data-cart-page-form]');
      if (!form || form.dataset.cartPageBound === 'true') return;

      form.dataset.cartPageBound = 'true';
      var status = form.querySelector('[data-cart-page-status]');
      var normalizeQuantity = function (input, requestedValue) {
        var min = Number(input.getAttribute('min') || 1);
        var step = Number(input.getAttribute('step') || 1);
        var maxAttribute = input.getAttribute('max');
        var max = maxAttribute === null || maxAttribute === '' ? null : Number(maxAttribute);
        if (!Number.isFinite(min) || min < 1) min = 1;
        if (!Number.isFinite(step) || step < 1) step = 1;
        var value = Number(requestedValue);
        if (!Number.isFinite(value)) value = min;
        value = Math.max(min, value);
        value = min + Math.floor((value - min) / step) * step;
        if (max !== null && Number.isFinite(max)) value = Math.min(max, value);
        input.value = String(value);
        var control = input.closest('.cart-item__quantity-control');
        var decrease = control && control.querySelector('[data-cart-page-quantity-decrease]');
        var increase = control && control.querySelector('[data-cart-page-quantity-increase]');
        if (decrease) decrease.disabled = value <= min;
        if (increase) increase.disabled = max !== null && Number.isFinite(max) && value >= max;
        return value;
      };
      var announceQuantityChange = function (input) {
        if (!status || !input) return;
        var message = String(form.dataset.quantityChanged || '')
          .replace('__TITLE__', input.dataset.productTitle || '')
          .replace('__QUANTITY__', input.value || '0');
        status.textContent = '';
        window.requestAnimationFrame(function () {
          status.textContent = message;
        });
      };

      form.addEventListener('click', function (event) {
        var button = event.target.closest && event.target.closest('[data-cart-page-quantity-decrease], [data-cart-page-quantity-increase]');
        if (!button || !form.contains(button)) return;

        var input = document.getElementById(button.getAttribute('aria-controls'));
        if (!input || !form.contains(input)) return;
        event.preventDefault();

        var step = Number(input.getAttribute('step') || 1);
        if (!Number.isFinite(step) || step < 1) step = 1;
        var delta = button.hasAttribute('data-cart-page-quantity-increase') ? step : -step;
        normalizeQuantity(input, Number(input.value || input.min || 1) + delta);
        announceQuantityChange(input);
      });

      form.addEventListener('change', function (event) {
        if (event.target.matches && event.target.matches('[data-cart-page-quantity-input]')) {
          normalizeQuantity(event.target, event.target.value);
          announceQuantityChange(event.target);
        }
      });

      form.querySelectorAll('[data-cart-page-quantity-input]').forEach(function (input) {
        normalizeQuantity(input, input.value);
      });
    };

    if (window.FidgetHQCartPage) {
      window.FidgetHQCartPage.init(document);
      return;
    }

    window.FidgetHQCartPage = { init: initCartPage };
    initCartPage(document);
    document.addEventListener('shopify:section:load', function (event) {
      initCartPage(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var select = function (selector, scope) {
    return (scope || document).querySelector(selector);
  };

  var selectAll = function (selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  };

  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  var rootsWithin = function (scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-product-root]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots = roots.concat(selectAll('[data-product-root]', scope));
    return roots;
  };

  var activateMedia = function (root, mediaId) {
    if (!root || !mediaId) return;
    var targetPanel = selectAll('[data-product-media-panel]', root).find(function (panel) {
      return String(panel.dataset.mediaId || '') === String(mediaId);
    });
    if (!targetPanel) return;

    var gallery = targetPanel.closest('.product-page__gallery');
    if (!gallery) return;
    var mediaIndex = targetPanel.dataset.mediaIndex;
    var currentPanel = select('[data-product-media-panel].is-active', gallery);
    var shouldAnimate = currentPanel && currentPanel !== targetPanel && !reducedMotionQuery.matches && typeof targetPanel.animate === 'function';
    var currentMediaIndex = currentPanel ? Number(currentPanel.dataset.mediaIndex || 0) : 0;
    var targetMediaIndex = Number(mediaIndex || 0);
    selectAll('[data-product-media-panel]', gallery).forEach(function (panel) {
      var isActive = panel === targetPanel;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        if (typeof panel.getAnimations === 'function') {
          panel.getAnimations().forEach(function (animation) {
            animation.cancel();
          });
        }
        panel.setAttribute('hidden', 'hidden');
        selectAll('video', panel).forEach(function (video) {
          video.pause();
        });
      }
    });

    if (shouldAnimate) {
      var direction = targetMediaIndex >= currentMediaIndex ? 1 : -1;
      targetPanel.animate([
        { opacity: 0, transform: 'translate3d(' + (direction * 12) + 'px, 0, 0) scale(0.992)' },
        { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' }
      ], {
        duration: 320,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
      });
    }
    selectAll('[data-product-thumbnail]', gallery).forEach(function (thumbnail) {
      var isActive = String(thumbnail.dataset.mediaId || '') === String(mediaId);
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-pressed', String(isActive));
    });
    selectAll('[data-product-media-dot]', gallery).forEach(function (dot) {
      dot.classList.toggle('is-active', dot.dataset.mediaIndex === mediaIndex);
    });
  };

  var selectedOptionValueIds = function (scope) {
    return selectAll('[data-product-option-input]:checked', scope).map(function (input) {
      return input.dataset.optionValueId || '';
    }).filter(Boolean);
  };

  var normalizeQuantityInput = function (input, requestedValue) {
    if (!input) return 0;
    var min = Number(input.getAttribute('min') || 1);
    var step = Number(input.getAttribute('step') || 1);
    var maxAttribute = input.getAttribute('max');
    var max = maxAttribute === null || maxAttribute === '' ? null : Number(maxAttribute);
    if (!Number.isFinite(min) || min < 1) min = 1;
    if (!Number.isFinite(step) || step < 1) step = 1;
    var value = Number(requestedValue);
    if (!Number.isFinite(value)) value = min;
    value = Math.max(min, value);
    value = min + Math.floor((value - min) / step) * step;
    if (max !== null && Number.isFinite(max)) value = Math.min(max, value);
    input.value = String(value);
    return value;
  };

  var setSelectionBusy = function (form, busy) {
    selectAll('[data-product-option-input], [data-selling-plan-input], [data-quantity-control] button, [data-quantity-control] input, [data-add-to-cart], [data-buy-now]', form).forEach(function (control) {
      if (busy) {
        control.dataset.variantBusyWasDisabled = String(control.disabled);
        control.disabled = true;
        return;
      }
      control.disabled = control.dataset.variantBusyWasDisabled === 'true';
      delete control.dataset.variantBusyWasDisabled;
    });

    var payment = select('.product-page__payment', form);
    var paymentAvailable = payment && payment.dataset.variantAvailable === 'true';
    if (payment) {
      payment.setAttribute('aria-disabled', String(busy || !paymentAvailable));
      if (busy || !paymentAvailable) {
        payment.setAttribute('inert', '');
      } else {
        payment.removeAttribute('inert');
      }
    }
    form.dataset.productReady = String(!busy);
    if (busy) {
      form.setAttribute('aria-busy', 'true');
    } else {
      form.removeAttribute('aria-busy');
    }
  };

  var initRoot = function (root) {
    if (!root || root.dataset.mainProductBound === 'true') return;
    var form = select('.product-page__form', root);
    var variantInput = form && select('[data-product-variant-id]', form);
    if (!form || !variantInput) return;
    root.dataset.mainProductBound = 'true';

    var optionInputs = selectAll('[data-product-option-input]', form);
    var addButton = select('[data-add-to-cart]', form);
    var buyButton = select('[data-buy-now]', form);
    var payment = select('.product-page__payment', form);
    var errorMessage = select('[data-product-form-error]', form);
    var shareButton = select('[data-share-url]', root);
    var requestController = null;
    var requestSequence = 0;
    var resizeObserver = null;
    var mutationObserver = null;
    var observedPaymentNodes = [];
    var paymentTimers = [];

    var setFormError = function (message) {
      if (!errorMessage) return;
      errorMessage.textContent = message || '';
      errorMessage.hidden = !message;
    };

    var clearShareFeedback = function () {
      if (!shareButton) return;
      if (shareButton._shareFeedbackTimer) {
        window.clearTimeout(shareButton._shareFeedbackTimer);
        shareButton._shareFeedbackTimer = null;
      }
      shareButton.classList.remove('is-feedback-visible', 'is-feedback-error');
      shareButton.dataset.feedback = '';
    };

    var announceShareFeedback = function (message, isError) {
      var status = shareButton && select('[data-share-status]', shareButton.parentElement);
      if (status) {
        status.textContent = '';
        window.requestAnimationFrame(function () {
          status.textContent = message || '';
        });
      }

      clearShareFeedback();
      if (!shareButton || !message) return;
      shareButton.dataset.feedback = message;
      shareButton.classList.toggle('is-feedback-error', Boolean(isError));
      shareButton.classList.add('is-feedback-visible');
      shareButton._shareFeedbackTimer = window.setTimeout(function () {
        clearShareFeedback();
      }, 2400);
    };

    var measurePaymentButton = function () {
      if (!payment || !root.isConnected) return;
      var candidates = selectAll([
        '.paypal-buttons',
        'iframe.component-frame.visible',
        'shopify-paypal-button',
        'shopify-accelerated-checkout',
        '.shopify-payment-button__button',
        '.shopify-payment-button'
      ].join(','), payment);
      var height = candidates.reduce(function (largest, element) {
        var rect = element.getBoundingClientRect();
        var style = window.getComputedStyle(element);
        var isVisible = style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height >= 32;
        if (!isVisible) return largest;
        return rect.height > largest ? rect.height : largest;
      }, 0);
      if (height >= 32) form.style.setProperty('--product-checkout-button-height', Math.round(height) + 'px');
    };

    var observePaymentNodes = function () {
      if (!resizeObserver || !payment) return;
      selectAll('shopify-accelerated-checkout, shopify-paypal-button, .shopify-payment-button, .shopify-payment-button__button, .paypal-buttons, iframe.component-frame.visible', payment).forEach(function (element) {
        if (observedPaymentNodes.indexOf(element) > -1) return;
        observedPaymentNodes.push(element);
        resizeObserver.observe(element);
      });
    };

    if (payment && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(measurePaymentButton);
      resizeObserver.observe(payment);
      observePaymentNodes();
    }
    if (payment && 'MutationObserver' in window) {
      mutationObserver = new MutationObserver(function () {
        observePaymentNodes();
        measurePaymentButton();
      });
      mutationObserver.observe(payment, { attributes: true, childList: true, subtree: true });
    }
    if (payment) {
      window.addEventListener('resize', measurePaymentButton);
      [0, 120, 400, 1000, 2500].forEach(function (delay) {
        paymentTimers.push(window.setTimeout(measurePaymentButton, delay));
      });
    }

    var handleClick = function (event) {
      var thumbnail = event.target.closest && event.target.closest('[data-product-thumbnail]');
      if (thumbnail && root.contains(thumbnail)) {
        event.preventDefault();
        activateMedia(root, thumbnail.dataset.mediaId);
        return;
      }

      var quantityButton = event.target.closest && event.target.closest('[data-quantity-minus], [data-quantity-plus]');
      if (quantityButton && root.contains(quantityButton)) {
        var quantityControl = quantityButton.closest('[data-quantity-control]');
        var quantityInput = quantityControl && select('input[name="quantity"]', quantityControl);
        if (!quantityInput) return;
        var step = Number(quantityInput.getAttribute('step') || 1);
        if (!Number.isFinite(step) || step < 1) step = 1;
        var delta = quantityButton.hasAttribute('data-quantity-plus') ? step : -step;
        normalizeQuantityInput(quantityInput, Number(quantityInput.value || quantityInput.min || 1) + delta);
        return;
      }

      var clickedShareButton = event.target.closest && event.target.closest('[data-share-url]');
      if (!clickedShareButton || clickedShareButton !== shareButton || !root.contains(clickedShareButton) || !clickedShareButton.dataset.shareUrl) return;
      if (navigator.share) {
        navigator.share({ title: clickedShareButton.dataset.shareTitle || document.title, url: clickedShareButton.dataset.shareUrl }).catch(function (error) {
          if (!error || error.name !== 'AbortError') announceShareFeedback(clickedShareButton.dataset.shareFailed, true);
        });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(clickedShareButton.dataset.shareUrl).then(function () {
          announceShareFeedback(clickedShareButton.dataset.shareCopied, false);
        }).catch(function () {
          announceShareFeedback(clickedShareButton.dataset.shareFailed, true);
        });
      } else {
        announceShareFeedback(clickedShareButton.dataset.shareFailed, true);
      }
    };
    root.addEventListener('click', handleClick);

    var syncSellingPlanSelection = function (input) {
      if (!input) return;
      var price = select('[data-product-price]', root);
      var unitPrice = select('[data-product-unit-price]', root);
      var unitPriceText = input.dataset.planUnitPrice || '';
      if (price) price.textContent = input.dataset.planPrice || '';
      if (unitPrice) {
        unitPrice.textContent = unitPriceText;
        unitPrice.hidden = !unitPriceText;
      }

      var publicUrl = new URL(window.location.href);
      if (input.value) {
        publicUrl.searchParams.set('selling_plan', input.value);
      } else {
        publicUrl.searchParams.delete('selling_plan');
      }
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', publicUrl.pathname + publicUrl.search + publicUrl.hash);
      }
      if (shareButton) shareButton.dataset.shareUrl = publicUrl.toString();
    };

    var handleChange = function (event) {
      var sellingPlanInput = event.target.closest && event.target.closest('[data-selling-plan-input]');
      if (sellingPlanInput && root.contains(sellingPlanInput)) {
        syncSellingPlanSelection(sellingPlanInput);
        return;
      }
      var quantityInput = event.target.closest && event.target.closest('[data-quantity-control] input[name="quantity"]');
      if (quantityInput && root.contains(quantityInput)) normalizeQuantityInput(quantityInput, quantityInput.value);
    };
    root.addEventListener('change', handleChange);

    var setInitialAvailability = function () {
      var hasVariant = Boolean(variantInput.value);
      var isAvailable = hasVariant && (!addButton || addButton.dataset.variantAvailable === 'true');
      variantInput.disabled = !hasVariant;
      if (addButton) addButton.disabled = !isAvailable;
      if (buyButton) buyButton.disabled = !isAvailable;
      if (payment) {
        payment.dataset.variantAvailable = String(isAvailable);
        payment.setAttribute('aria-disabled', String(!isAvailable));
        if (isAvailable) {
          payment.removeAttribute('inert');
        } else {
          payment.setAttribute('inert', '');
        }
      }
      form.dataset.productReady = 'true';
      form.removeAttribute('aria-busy');
      setFormError('');
    };

    var restoreOptionValues = function (optionValueIds) {
      optionInputs.forEach(function (input) {
        input.checked = optionValueIds.indexOf(input.dataset.optionValueId || '') > -1;
      });
    };

    var findReplacementFocus = function (nextRoot, focusState) {
      var nextInputs = selectAll('[data-product-option-input]', nextRoot);
      return nextInputs.find(function (input) {
        return focusState.optionValueId && input.dataset.optionValueId === focusState.optionValueId;
      }) || nextInputs.find(function (input) {
        return input.dataset.optionPosition === focusState.position && input.value === focusState.value;
      }) || nextInputs.find(function (input) {
        return input.dataset.optionPosition === focusState.position && input.checked;
      }) || nextInputs.find(function (input) {
        return input.checked;
      });
    };

    var updatePublicUrl = function (nextRoot, optionValueIds) {
      var publicUrl = new URL(nextRoot.dataset.productUrl || window.location.pathname, window.location.origin);
      var nextVariantInput = select('[data-product-variant-id]', nextRoot);
      publicUrl.searchParams.delete('section_id');
      publicUrl.searchParams.delete('variant');
      publicUrl.searchParams.delete('option_values');
      publicUrl.searchParams.delete('selling_plan');
      if (nextVariantInput && nextVariantInput.value) {
        publicUrl.searchParams.set('variant', nextVariantInput.value);
      } else if (optionValueIds.length) {
        publicUrl.searchParams.set('option_values', optionValueIds.join(','));
      }
      var nextSellingPlan = select('[data-selling-plan-input]:checked', nextRoot);
      if (nextSellingPlan && nextSellingPlan.value) {
        publicUrl.searchParams.set('selling_plan', nextSellingPlan.value);
      }
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', publicUrl.pathname + publicUrl.search + window.location.hash);
      }
      var shareButton = select('[data-share-url]', nextRoot);
      if (shareButton) shareButton.dataset.shareUrl = publicUrl.toString();
      return nextVariantInput;
    };

    var announceSelection = function (nextRoot) {
      var status = select('[data-product-variant-status]', nextRoot);
      if (!status) return;
      var options = selectAll('[data-product-option-input]:checked', nextRoot).map(function (input) {
        return input.value;
      });
      var message = String(nextRoot.dataset.optionsUpdatedLabel || '').replace('__OPTIONS__', options.join(', '));
      status.textContent = '';
      window.requestAnimationFrame(function () {
        status.textContent = message;
      });
    };

    var replaceSection = function (responseText, requestUrl, focusState, quantity) {
      var responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
      var nextRoot = select('[data-product-root]', responseDocument);
      if (!nextRoot || nextRoot.dataset.sectionId !== root.dataset.sectionId) {
        throw new Error(root.dataset.variantLoadError || '');
      }

      requestController = null;
      if (root._mainProductCleanup) root._mainProductCleanup();
      root.replaceWith(nextRoot);
      var nextQuantity = select('input[name="quantity"]', nextRoot);
      if (nextQuantity && quantity !== '') normalizeQuantityInput(nextQuantity, quantity);
      nextRoot.classList.add('is-entering');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          nextRoot.classList.remove('is-entering');
        });
      });
      initRoot(nextRoot);
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
      document.dispatchEvent(new CustomEvent('product:section-replaced', { detail: { root: nextRoot } }));

      var nextOptionValueIds = selectedOptionValueIds(nextRoot);
      var nextVariantInput = updatePublicUrl(nextRoot, nextOptionValueIds);
      announceSelection(nextRoot);
      var focusTarget = findReplacementFocus(nextRoot, focusState);
      if (focusTarget) {
        try {
          focusTarget.focus({ preventScroll: true });
        } catch (error) {
          focusTarget.focus();
        }
      }

      var nextForm = select('.product-page__form', nextRoot);
      var nextAddButton = nextForm && select('[data-add-to-cart]', nextForm);
      if (nextForm) {
        nextForm.dispatchEvent(new CustomEvent('product:variant-change', {
          bubbles: true,
          detail: {
            variant: nextVariantInput && nextVariantInput.value ? {
              id: nextVariantInput.value,
              available: Boolean(nextAddButton && nextAddButton.dataset.variantAvailable === 'true')
            } : null,
            url: requestUrl.pathname
          }
        }));
      }
    };

    var handleOptionChange = function (input) {
      var previousOptionValueIds = root._selectedOptionValueIds || [];
      var nextOptionValueIds = selectedOptionValueIds(form);
      var requestUrl = new URL(input.dataset.productUrl || root.dataset.productUrl || window.location.pathname, window.location.origin);
      requestUrl.searchParams.delete('variant');
      requestUrl.searchParams.set('section_id', root.dataset.sectionId);
      requestUrl.searchParams.delete('selling_plan');
      var selectedSellingPlan = select('[data-selling-plan-input]:checked', form);
      if (selectedSellingPlan && selectedSellingPlan.value) {
        requestUrl.searchParams.set('selling_plan', selectedSellingPlan.value);
      }
      if (nextOptionValueIds.length) {
        requestUrl.searchParams.set('option_values', nextOptionValueIds.join(','));
      } else {
        requestUrl.searchParams.delete('option_values');
      }

      var quantityInput = select('input[name="quantity"]', form);
      var quantity = quantityInput ? quantityInput.value : '';
      var focusState = {
        optionValueId: input.dataset.optionValueId || '',
        position: input.dataset.optionPosition || '',
        value: input.value
      };
      var currentRequest = ++requestSequence;
      if (requestController) requestController.abort();
      requestController = typeof AbortController === 'function' ? new AbortController() : null;
      setSelectionBusy(form, true);
      setFormError('');
      root.classList.add('is-swapping');

      var requestOptions = {
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      };
      if (requestController) requestOptions.signal = requestController.signal;
      fetch(requestUrl.toString(), requestOptions).then(function (response) {
        if (!response.ok) throw new Error(root.dataset.variantLoadError || '');
        return response.text();
      }).then(function (responseText) {
        if (currentRequest !== requestSequence) return;
        replaceSection(responseText, requestUrl, focusState, quantity);
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (currentRequest !== requestSequence || !root.isConnected) return;
        restoreOptionValues(previousOptionValueIds);
        root.classList.remove('is-swapping');
        setSelectionBusy(form, false);
        setFormError(root.dataset.variantLoadError || error.message || '');
      }).finally(function () {
        if (currentRequest === requestSequence) requestController = null;
      });
    };

    root._selectedOptionValueIds = selectedOptionValueIds(form);
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        handleOptionChange(input);
      });
    });

    root._mainProductCleanup = function () {
      requestSequence += 1;
      if (requestController) requestController.abort();
      root.removeEventListener('click', handleClick);
      root.removeEventListener('change', handleChange);
      if (resizeObserver) resizeObserver.disconnect();
      if (mutationObserver) mutationObserver.disconnect();
      if (payment) window.removeEventListener('resize', measurePaymentButton);
      clearShareFeedback();
      paymentTimers.forEach(function (timer) {
        window.clearTimeout(timer);
      });
      delete root.dataset.mainProductBound;
      delete root._selectedOptionValueIds;
      delete root._mainProductCleanup;
    };
    setInitialAvailability();
  };

  var initWithin = function (scope) {
    rootsWithin(scope).forEach(initRoot);
  };

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsWithin(event.target).forEach(function (root) {
      if (root._mainProductCleanup) root._mainProductCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    }, { once: true });
  } else {
    initWithin(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const runtimeKey = '__FHQRecentlyViewedRuntimeV3';
  const existingRuntime = window[runtimeKey];
  if (existingRuntime) {
    if (existingRuntime.version === 3 && typeof existingRuntime.initializeAll === 'function') {
      existingRuntime.initializeAll(document);
    }
    return;
  }

  const storageKey = 'fhq-recently-viewed-v3';
  const legacyStorageKey = 'fhq-recently-viewed-v2';
  const storageVersion = 3;
  const historyLimit = 12;
  const minute = 60 * 1000;
  const historyTtl = 30 * 24 * 60 * minute;
  const imageTtl = 7 * 24 * 60 * minute;
  const priceTtl = 15 * minute;
  const storageByteLimit = 32768;
  const rootStates = new WeakMap();
  let memoryEnvelope = { version: storageVersion, context: null, updatedAt: 0, items: [] };
  let storageLoaded = false;
  let privacyGeneration = 0;
  let privacyState = null;

  const readPrivacyState = () => {
    const privacy = window.FHQPrivacy;
    if (
      !privacy ||
      typeof privacy.isReady !== 'function' ||
      typeof privacy.isAvailable !== 'function' ||
      typeof privacy.preferencesAllowed !== 'function'
    ) return null;
    try {
      return {
        ready: privacy.isReady() === true,
        available: privacy.isAvailable() === true,
        preferences: privacy.preferencesAllowed() === true
      };
    } catch (error) {
      return { ready: false, available: false, preferences: false };
    }
  };

  const preferencesAllowed = () => Boolean(
    privacyState &&
    privacyState.ready &&
    privacyState.available &&
    privacyState.preferences
  );

  const sameContext = (left, right) => Boolean(
    left &&
    right &&
    left.locale === right.locale &&
    left.currency === right.currency
  );

  const normalizeContext = (locale, currency) => {
    const normalizedLocale = typeof locale === 'string' ? locale.trim() : '';
    const normalizedCurrency = typeof currency === 'string' ? currency.trim() : '';
    if (!/^[A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/.test(normalizedLocale) || normalizedLocale.length > 35) return null;
    if (!/^[A-Z]{3}$/.test(normalizedCurrency)) return null;
    return { locale: normalizedLocale, currency: normalizedCurrency };
  };

  const validTimestamp = (value, now, maxAge) => Number.isSafeInteger(value) &&
    value > 0 &&
    value <= now &&
    now - value <= maxAge;

  const normalizeHandle = (value) => {
    const handle = typeof value === 'string' ? value.trim() : '';
    return /^[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?$/.test(handle) ? handle : '';
  };

  const normalizeProductUrl = (value, handle) => {
    if (typeof value !== 'string' || !value || value.length > 2048) return '';
    try {
      const url = new URL(value, window.location.origin);
      const routesRoot = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
      const rootPath = routesRoot.pathname.endsWith('/') ? routesRoot.pathname : `${routesRoot.pathname}/`;
      const expectedPath = `${rootPath}products/${handle}`;
      if (
        url.origin !== window.location.origin ||
        url.protocol !== window.location.protocol ||
        !/^https?:$/.test(url.protocol) ||
        url.username ||
        url.password ||
        url.search ||
        url.hash
      ) return '';
      if (routesRoot.origin !== window.location.origin || routesRoot.search || routesRoot.hash || url.pathname !== expectedPath) return '';
      return url.pathname;
    } catch (error) {
      return '';
    }
  };

  const normalizeImageUrl = (value) => {
    if (typeof value !== 'string' || !value || value.length > 2048) return '';
    try {
      const url = new URL(value, window.location.href);
      const sameOriginImage = url.origin === window.location.origin &&
        url.protocol === window.location.protocol &&
        /^https?:$/.test(url.protocol) &&
        url.pathname.startsWith('/cdn/');
      const shopifyCdnImage = url.protocol === 'https:' && url.hostname === 'cdn.shopify.com';
      if ((!sameOriginImage && !shopifyCdnImage) || url.username || url.password) return '';
      return url.href;
    } catch (error) {
      return '';
    }
  };

  const normalizeImage = (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    const src360 = normalizeImageUrl(value.src360);
    const src720 = normalizeImageUrl(value.src720);
    return src360 || src720 ? { src360, src720 } : null;
  };

  const normalizeItem = (item, context, now, maxObservedAt = now) => {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return null;
    const handle = normalizeHandle(item.handle);
    const url = normalizeProductUrl(item.url, handle);
    const title = typeof item.title === 'string' ? item.title.trim() : '';
    if (!handle || !url || !title || title.length > 240) return null;
    if (item.locale !== context.locale || item.currency !== context.currency) return null;
    if (!validTimestamp(item.viewedAt, now, historyTtl)) return null;
    if (item.viewedAt > maxObservedAt) return null;

    let price = '';
    let priceObservedAt = null;
    if (item.price !== undefined && item.price !== null && item.price !== '') {
      if (typeof item.price !== 'string' || item.price.length > 64) return null;
      price = item.price.trim();
      if (!price || !validTimestamp(item.priceObservedAt, now, historyTtl)) return null;
      if (item.priceObservedAt < item.viewedAt || item.priceObservedAt - item.viewedAt > minute) return null;
      if (item.priceObservedAt > maxObservedAt) return null;
      priceObservedAt = item.priceObservedAt;
    }

    return {
      handle,
      url,
      title,
      image: normalizeImage(item.image),
      locale: context.locale,
      currency: context.currency,
      viewedAt: item.viewedAt,
      priceObservedAt,
      price
    };
  };

  const normalizeItems = (items, context, now, maxObservedAt = now) => {
    const newestByHandle = new Map();
    for (const item of Array.isArray(items) ? items : []) {
      const safeItem = normalizeItem(item, context, now, maxObservedAt);
      if (!safeItem) continue;
      const existingItem = newestByHandle.get(safeItem.handle);
      if (!existingItem || safeItem.viewedAt > existingItem.viewedAt) newestByHandle.set(safeItem.handle, safeItem);
    }
    return [...newestByHandle.values()]
      .sort((left, right) => right.viewedAt - left.viewedAt || (left.handle < right.handle ? -1 : left.handle > right.handle ? 1 : 0))
      .slice(0, historyLimit);
  };

  const serializedBytes = (value) => new TextEncoder().encode(JSON.stringify(value)).byteLength;

  const makeEnvelope = (context, items, now, updatedAt = now) => {
    const envelope = {
      version: storageVersion,
      context: { locale: context.locale, currency: context.currency },
      updatedAt,
      items: normalizeItems(items, context, now, updatedAt)
    };
    while (envelope.items.length && serializedBytes(envelope) > storageByteLimit) envelope.items.pop();
    return envelope;
  };

  const parseEnvelope = (value, context, now) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    if (value.version !== storageVersion || !sameContext(value.context, context)) return null;
    if (!validTimestamp(value.updatedAt, now, historyTtl)) return null;
    return makeEnvelope(context, value.items, now, value.updatedAt);
  };

  const readHistory = (context, now) => {
    if (!preferencesAllowed()) return [];
    if (storageLoaded && sameContext(memoryEnvelope.context, context)) {
      memoryEnvelope = parseEnvelope(memoryEnvelope, context, now) || makeEnvelope(context, [], now);
      return [...memoryEnvelope.items];
    }

    let storedEnvelope = null;
    let storageAvailable = false;
    try {
      window.localStorage.removeItem(legacyStorageKey);
      const rawValue = window.localStorage.getItem(storageKey);
      storedEnvelope = rawValue && new TextEncoder().encode(rawValue).byteLength <= storageByteLimit
        ? parseEnvelope(JSON.parse(rawValue), context, now)
        : makeEnvelope(context, [], now);
      storageAvailable = true;
    } catch (error) {
      /* Consent-gated memory remains usable for this page lifecycle only. */
    }

    if (storageAvailable) {
      memoryEnvelope = storedEnvelope || makeEnvelope(context, [], now);
    } else if (!sameContext(memoryEnvelope.context, context)) {
      memoryEnvelope = makeEnvelope(context, [], now);
    }
    storageLoaded = true;
    return [...memoryEnvelope.items];
  };

  const writeHistory = (context, items, now) => {
    if (!preferencesAllowed()) return;
    memoryEnvelope = makeEnvelope(context, items, now);
    storageLoaded = true;

    try {
      window.localStorage.removeItem(legacyStorageKey);
      window.localStorage.setItem(storageKey, JSON.stringify(memoryEnvelope));
    } catch (error) {
      /* Keep only the in-memory, consent-gated session fallback. */
    }
  };

  const createPlaceholder = () => {
    const placeholder = document.createElement('span');
    placeholder.className = 'recently-viewed__placeholder';
    return placeholder;
  };

  const createCard = (item, now) => {
    const article = document.createElement('article');
    article.className = 'recently-viewed__card';

    const link = document.createElement('a');
    link.className = 'recently-viewed__media';
    link.href = item.url;
    link.tabIndex = -1;
    link.setAttribute('aria-hidden', 'true');

    const imageFresh = item.image && validTimestamp(item.viewedAt, now, imageTtl);
    if (imageFresh) {
      const image = document.createElement('img');
      const srcset = [];
      if (item.image.src360) srcset.push(`${item.image.src360} 360w`);
      if (item.image.src720) srcset.push(`${item.image.src720} 720w`);
      if (srcset.length) image.srcset = srcset.join(', ');
      image.sizes = '(min-width: 900px) 25vw, (min-width: 480px) 50vw, 100vw';
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', () => {
        if (image.parentNode) image.replaceWith(createPlaceholder());
      }, { once: true });
      image.src = item.image.src720 || item.image.src360;
      link.append(image);
    } else {
      link.append(createPlaceholder());
    }

    const body = document.createElement('div');
    body.className = 'recently-viewed__body';
    const title = document.createElement('h3');
    const titleLink = document.createElement('a');
    titleLink.href = item.url;
    titleLink.textContent = item.title;
    title.append(titleLink);
    body.append(title);
    if (item.price && validTimestamp(item.priceObservedAt, now, priceTtl)) {
      const price = document.createElement('p');
      price.textContent = item.price;
      body.append(price);
    }
    article.append(link, body);
    return article;
  };

  const currentSnapshot = (root, context, now) => {
    const handle = normalizeHandle(root.dataset.currentHandle);
    const url = normalizeProductUrl(root.dataset.currentUrl, handle);
    const title = typeof root.dataset.currentTitle === 'string' ? root.dataset.currentTitle.trim() : '';
    if (!handle || !url || !title || title.length > 240) return null;
    const price = typeof root.dataset.currentPrice === 'string' ? root.dataset.currentPrice.trim() : '';
    if (price.length > 64) return null;
    return normalizeItem({
      handle,
      url,
      title,
      image: {
        src360: root.dataset.currentImage360 || '',
        src720: root.dataset.currentImage720 || ''
      },
      locale: context.locale,
      currency: context.currency,
      viewedAt: now,
      priceObservedAt: price ? now : null,
      price
    }, context, now);
  };

  const initialize = (root) => {
    if (!root || rootStates.has(root) || !preferencesAllowed()) return;
    root.hidden = true;
    const grid = root.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    grid.replaceChildren();

    const context = normalizeContext(root.dataset.currentLocale, root.dataset.currentCurrency);
    const now = Date.now();
    const snapshot = context ? currentSnapshot(root, context, now) : null;
    if (!context || !snapshot) return;
    const generation = privacyGeneration;
    const state = { generation, revealFrame: null };
    rootStates.set(root, state);
    const history = readHistory(context, now).filter((item) => item.handle !== snapshot.handle);
    const parsedLimit = Number.parseInt(root.dataset.limit || '', 10);
    const visibleLimit = Math.min(8, Math.max(2, Number.isSafeInteger(parsedLimit) ? parsedLimit : 4));
    const visibleItems = history.slice(0, visibleLimit);
    writeHistory(context, [snapshot, ...history], now);
    if (!visibleItems.length || generation !== privacyGeneration || !preferencesAllowed()) return;
    visibleItems.forEach((item) => grid.append(createCard(item, now)));
    if (!grid.children.length || !root.isConnected) return;
    root.hidden = false;
    state.revealFrame = window.requestAnimationFrame(() => {
      state.revealFrame = null;
      if (
        generation === privacyGeneration &&
        preferencesAllowed() &&
        root.isConnected &&
        rootStates.get(root) === state &&
        window.FHQHomeMotion
      ) window.FHQHomeMotion.reveal(root);
    });
  };

  const rootsIn = (scope) => {
    const roots = [];
    if (scope && typeof scope.matches === 'function' && scope.matches('[data-recently-viewed]')) roots.push(scope);
    if (scope && typeof scope.querySelectorAll === 'function') roots.push(...scope.querySelectorAll('[data-recently-viewed]'));
    return roots;
  };

  const initializeAll = (scope = document) => {
    rootsIn(scope).forEach(initialize);
  };

  const destroyRoot = (root) => {
    const state = rootStates.get(root);
    if (state && state.revealFrame !== null) window.cancelAnimationFrame(state.revealFrame);
    rootStates.delete(root);
    root.hidden = true;
    const grid = root.querySelector('[data-recently-viewed-grid]');
    if (grid) grid.replaceChildren();
  };

  const resetRoots = () => {
    rootsIn(document).forEach(destroyRoot);
  };

  const clearSessionHistory = () => {
    memoryEnvelope = { version: storageVersion, context: null, updatedAt: 0, items: [] };
    storageLoaded = false;
  };

  const clearStoredHistory = () => {
    clearSessionHistory();
    try {
      window.localStorage.removeItem(legacyStorageKey);
      window.localStorage.removeItem(storageKey);
    } catch (error) {
      /* Denial remains fail-closed even when storage cleanup is unavailable. */
    }
  };

  const applyPrivacyState = (next) => {
    if (
      !next ||
      typeof next.ready !== 'boolean' ||
      typeof next.available !== 'boolean' ||
      typeof next.preferences !== 'boolean'
    ) return;
    if (
      privacyState &&
      privacyState.ready === next.ready &&
      privacyState.available === next.available &&
      privacyState.preferences === next.preferences
    ) return;
    privacyState = {
      ready: next.ready,
      available: next.available,
      preferences: next.preferences
    };
    privacyGeneration += 1;
    resetRoots();
    clearSessionHistory();
    if (preferencesAllowed()) {
      initializeAll(document);
    } else if (next.ready && next.available) {
      clearStoredHistory();
    }
  };

  window[runtimeKey] = {
    version: storageVersion,
    initializeAll,
    destroyRoot
  };

  const applyCurrentPrivacyState = () => {
    const currentState = readPrivacyState();
    if (currentState) applyPrivacyState(currentState);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCurrentPrivacyState, { once: true });
  } else {
    applyCurrentPrivacyState();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => rootsIn(event.target).forEach(destroyRoot));
  document.addEventListener('fhq:privacy-changed', (event) => {
    const detail = event && event.detail;
    if (
      !detail ||
      typeof detail.ready !== 'boolean' ||
      typeof detail.available !== 'boolean' ||
      typeof detail.preferences !== 'boolean'
    ) return;
    applyPrivacyState({
      ready: detail.ready,
      available: detail.available,
      preferences: detail.preferences
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
